export const THREAD_FILTERS = {
  inbox: 'inbox',
  archived: 'archived',
};

export function timestampToMillis(value) {
  if (!value) return null;
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (value instanceof Date) return value.getTime();
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value === 'string') {
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? null : parsed;
  }
  return null;
}

export function getThreadState(threadStates = {}, threadId = '') {
  return threadStates?.[threadId] || null;
}

export function getDeletedBefore(state = null) {
  return state?.deletedBefore || null;
}

export function isThreadArchived(state = null) {
  return Boolean(state?.archivedAt);
}

export function isThreadDeletedHidden(thread = {}, state = null) {
  const deletedAt = timestampToMillis(state?.deletedBefore);
  if (!deletedAt) return false;

  const reopenedAt = timestampToMillis(state?.reopenedAt);
  if (reopenedAt && reopenedAt >= deletedAt) return false;

  const lastUpdated = timestampToMillis(thread?.lastUpdated);
  return !lastUpdated || lastUpdated <= deletedAt;
}

export function shouldShowThread(thread = {}, state = null, filter = THREAD_FILTERS.inbox) {
  if (isThreadDeletedHidden(thread, state)) return false;

  const archived = isThreadArchived(state);
  if (filter === THREAD_FILTERS.archived) return archived;
  return !archived;
}

function getDuplicateThreadKey(thread = {}) {
  const participants = Array.from(new Set((Array.isArray(thread.participants) ? thread.participants : []).filter(Boolean))).sort();
  if (participants.length < 2) return null;
  const teamId = typeof thread.teamId === 'string' && thread.teamId.trim() ? thread.teamId.trim() : null;
  return JSON.stringify({ teamId, participants });
}

function hasThreadPreview(thread = {}) {
  return Boolean(
    (typeof thread.lastMessage === 'string' && thread.lastMessage.trim())
    || thread.lastMessageIsBroadcast
    || thread.lastBroadcastId
  );
}

export function removeBlankDuplicateThreads(threads = []) {
  const groups = new Map();
  threads.forEach((thread) => {
    const key = getDuplicateThreadKey(thread);
    if (!key) return;
    const group = groups.get(key) || { total: 0, previewCount: 0, keptBlankId: '' };
    group.total += 1;
    if (hasThreadPreview(thread)) {
      group.previewCount += 1;
    } else if (!group.keptBlankId) {
      group.keptBlankId = thread.id;
    }
    groups.set(key, group);
  });

  return threads.filter((thread) => {
    const key = getDuplicateThreadKey(thread);
    if (!key) return true;
    const group = groups.get(key);
    if (!group || group.total < 2) return true;
    if (hasThreadPreview(thread)) return true;
    return group.previewCount === 0 && thread.id === group.keptBlankId;
  });
}
